<template>
  <div class="table-panel" :class="className || ''">
    <div class="vue-element-table">
      <el-table
        ref="table"
        :stripe="stripe"
        :data="tableData"
        border
        :max-height="maxHeight"
        @row-click="handleRowClick"
        :highlight-current-row="highLight"
        @current-change="handleCurrentRowChange"
        @selection-change="handleSelectionChange"
        @cell-click="handleCellClick"
        :cell-style="{ padding: '0', height: '34px' }"
        :span-method="arraySpanMethod"
        :header-cell-style="{
          height: '34px',
          background: '#F7F9FC',
          padding: '0',
        }"
      >
        <!-- 序号列 -->
        <el-table-column
          v-if="showIndex"
          type="index"
          :index="indexMethod"
          :align="align"
          width="50"
        >
        </el-table-column>
        <!-- 展开列 -->
        <el-table-column
          v-if="expandColumns && expandColumns.length"
          type="expand"
          show-overflow-tooltip
        >
          <template slot-scope="props">
            <el-form label-position="left" inline class="inner-table-expand">
              <el-form-item
                v-for="column in expandColumns"
                :key="Math.random()"
                :label="column.label"
              >
                <span v-if="!!column.formatter">
                  {{
                    column.formatter(
                      props.$index,
                      props.row[column.field],
                      props.row
                    )
                  }}
                </span>
                <span
                  v-else-if="!!column.formatterHTML"
                  v-html="
                    column.formatterHTML(
                      props.$index,
                      props.row[column.field],
                      props.row
                    )
                  "
                ></span>
                <span v-else>{{ props.row[column.field] }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <!-- checkbox列 -->
        <el-table-column
          v-if="isCheckbox"
          type="selection"
          :selectable="checkSelectable"
          :align="align"
          width="50"
        >
        </el-table-column>
        <!-- 数据字段列 -->
        <el-table-column
          v-for="(column, index) in columns"
          :key="'cols_' + index"
          show-overflow-tooltip
          :fixed="column.fixed"
          :align="align"
          :label="column.label"
          :width="column.width"
          :min-width="column.minWidth"
          :class-name="column.className"
        >
          <template slot-scope="scope">
            <div v-if="!column.field">
              <template v-if="column.buttons">
                <template v-for="(button, idx) in column.buttons || []">
                  <el-button
                    style="margin: 0 10px"
                    v-if="
                      button.show ? button.show(scope.$index, scope.row) : true
                    "
                    :key="idx"
                    :type="button.type || ''"
                    :plain="button.plain || false"
                    :icon="button.icon || ''"
                    :size="button.size || 'mini'"
                    :class="button.customClass || ''"
                    :disabled="
                      typeof button.disabled === 'function'
                        ? button.disabled(scope.$index, scope.row)
                        : button.disabled
                    "
                    @click="
                      operateCallback(scope.$index, scope.row, button.callback)
                    "
                  >
                    <!-- <template v-if="button.show ? button.show(scope.$index, scope.row): true"> -->
                    {{
                      typeof button.title === "function"
                        ? button.title(scope.$index, scope.row)
                        : button.title
                    }}
                    <!-- </template> -->
                  </el-button>
                </template>
              </template>
              <template v-if="column.switch">
                <el-switch
                  :value="scope.row[column.switch.type]?true:false"
                  :active-color="column.switch.activeColor || '#13ce66'"
                  :inactive-color="column.switch.inactiveColor || '#cccccc'"
                  @change="operateCallback(scope.$index, scope.row, column.switch.callback)"
                >
                </el-switch>
              </template>
            </div>
            <div v-else-if="!!column.formatter">
              {{
                column.formatter(
                  scope.$index,
                  scope.row[column.field],
                  scope.row,
                  scope
                )
              }}
            </div>
            <div v-else-if="!!column.formatterHTML">
              <span
                v-html="
                  column.formatterHTML(
                    scope.$index,
                    scope.row[column.field],
                    scope.row,
                    scope
                  )
                "
              ></span>
            </div>
            <div v-else-if="!!column.formatterPopover">
              <el-popover
                v-if="
                  column.formatterPopover(
                    scope.$index,
                    scope.row[column.field],
                    scope.row
                  ).content
                "
                class="warn-popover"
                placement="right-end"
                width="150"
                trigger="hover"
                :content="
                  column.formatterPopover(
                    scope.$index,
                    scope.row[column.field],
                    scope.row
                  ).content
                "
              >
                <span
                  slot="reference"
                  v-html="
                    column.formatterPopover(
                      scope.$index,
                      scope.row[column.field],
                      scope.row
                    ).html
                  "
                ></span>
              </el-popover>
              <span
                v-else
                v-html="
                  column.formatterPopover(
                    scope.$index,
                    scope.row[column.field],
                    scope.row
                  ).html
                "
              ></span>
            </div>
            <div v-else>{{ scope.row[column.field] }}</div>
          </template>
        </el-table-column>
        <div slot="empty">{{ emptyText || "暂无数据" }}</div>
      </el-table>
    </div>
    <div class="pagination overfix" v-if="!paginateHidden">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-size="_pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="_pageSizes"
        :total="totalNumber"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { Loading } from "element-ui";

export default {
  name: "SingleTablePanel",
  computed: {
    disabledCheckbox() {
      if (!this.checkDisableList) return false;
      const { key, value } = this.checkDisableList;
      return {
        key,
        value,
      };
    },
    totalNumber() {
      return this.total != null
        ? this.total || 0
        : (this.tableData && this.tableData.length) || 0;
    },
    _pageSize: {
      get() {
        return this.pageSize;
      },
      set(val) {},
    },
    _pageSize2: {
      get() {
        return this.pageSizes;
      },
      set(val) {},
    },
    _pageSizes: {
      get() {
        let arr = [5, 10, 20, 30];
        if (!this._pageSize2) {
          return arr;
        } else {
          arr.push(this._pageSize2);
          let x = new Set(arr);
          let arr2 = [...x];
          arr2.sort((a, b) => {
            return a - b;
          });
          return arr2;
        }
      },
      set(val) {},
    },
  },
  data: function () {
    return {
      loading: false,
      searchObj: {},
      currentPage: 1,
      flag: false,
      loadingInstance: {},
    };
  },
  props: {
    stripe: false,
    className: null,
    columns: null,
    expandColumns: null,
    rowsKey: null,
    isCheckbox: null,
    checkDisableList: null,
    maxHeight: null,
    tableData: null,
    highLight: {
      type: Boolean,
      default: false,
    }, // 点击高亮 回调事件 handleCurrentRowChange
    align: null,
    fixed: {
      type: Boolean,
      default: false,
    },
    dispatchProps: null,
    total: null,
    emptyText: null,
    currRow: null,
    forbidAutoSearch: null,
    pageSize: {
      type: null,
      default: 10,
    },
    pageSizes: {
      type: null,
      default: 10,
    },
    noPageSize: {
      type: Boolean,
      default: false,
    },
    paginateHidden: {
      type: Boolean,
      default: false,
    },
    showIndex: {
      type: Boolean,
      default: false,
    },
    arraySpanMethod: {
      type: Function,
      default: null,
    },
  },
  watch: {
    loading(n) {
      let target = this.$refs.table.$el;
      if (n) {
        this.loadingInstance = Loading.service({
          target: target,
        });
      } else {
        this.loadingInstance.close ? this.loadingInstance.close() : "";
      }
    },
    pageSize(n) {
      /* if(this.currentPage > Math.ceil(this.totalNumber/n)) {
        this.$parent.$on('ok', () => {
            this.flag = true;
            this.searchList()
            this.$off('ok');
          })
      } else {
        this.flag = true;
        this.searchList()
      } */
    },
    // currentPage(newVal, oldVal) {
    /* this.$emit('ok', true);
      if(oldVal > Math.ceil(this.totalNumber/this._pageSize)) {
        this.flag = true;
        this.searchList()
        this.$off('ok');
      } */
    // }
  },
  created() {},
  destroyed: function () {
    let $parent = this.$parent;
    $parent.$off("list.table.delete");
    $parent.$off("list.table.add");
    $parent.$off("list.table.refresh");
    $parent.$off("execute.search.action");
    $parent.$parent.$off("execute.search.action");
  },
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    checkSelectable(row) {
      if (!this.disabledCheckbox) return true;
      let { key, value } = this.disabledCheckbox;
      return !(value.indexOf(row[key]) > -1);
    },
    handleCellClick(row, column, cell) {
      let param = {
        row,
        column,
        cell,
      };
      let $parent = this.$parent;
      $parent.$emit("click:currCell", param);
    },
    handleCurrentRowChange(row) {
      this.$emit("update:currRow", row);
    },
    handleSelectionChange(val) {
      let $parent = this.$parent;
      console.log("val:", val);
      $parent.$emit("selection", val);
      this.$emit("selection", val);
    },
    handleRowClick(row) {
      this.$emit("update:currRow", row);
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      let $parent = this.$parent;
      let $parent2 = $parent.$parent;
      this.$root.$emit("pageSize", { val, el: this.$el });
      this.$root.$emit("currentPage", { val: 1, el: this.$el });
      // $parent.$emit('pageSize', {val,el:this.$el});
      // $parent2.$emit('pageSize', {val,el:this.$el});
    },
    handleCurrentChange(val) {
      this.$root.$emit("currentPage", { val, el: this.$el });
    },
    changeCurrentPage(val) {
      this.currentPage = val;
    },
    operateCallback: function (index, row, fn) {
      fn && fn(index, row);
    },
  },
};
</script>
<style type="text/css" rel="stylesheet/scss" lang="scss" scoped>
.el-table--border {
  // border-left: none;
}
.table-panel {
  height: 100%;
  width: 100%;
  // width: calc(100% - 60px);
  // margin: 0 30px;
  .vue-element-table {
    height: 100%;
    overflow: auto;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 6px;
      height: 50px;
      box-shadow: inset 0 0 4px transparent;
      background: #e2e2e2;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 4px transparent;
      border-radius: 4px;
      background: #ffffff;
    }
  }
  .inner-table-expand {
    font-size: 0;
    label {
      width: 90px;
      color: #99a9bf;
    }
    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 30%;
    }
  }
  .el-table__expand-column {
    i {
      font-size: 12px;
    }
  }
  .warn-popover {
    .el-popover {
      background-color: #ff5b4f;
      padding: 4px 10px;
      color: #fff;
    }
  }
  .pagination {
    background: #fff;
    margin-top: 10px;
  }
}
/deep/.el-table tbody tr:hover > td {
  background-color: rgba(70, 214, 255, 0.05) !important;
}
/deep/.el-pagination {
  .el-select .el-input .el-input__inner {
    border-radius: 0;
  }
}
/deep/.el-table tr {
  font-size: 14px;
  height: 55px;
  color: #666666;
  td,
  th {
    border: 0;
  }
  .th {
    font-weight: bold;
  }
  .el-button {
    width: 40px;
    height: 25px;
    padding: 0;
    margin: 0 5px !important;
  }
  .bigbtn {
    width: 100px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SingleTablePanel.vue